import { isExternalUrl } from '@sitemule/ng-components/utils/isExternalUrl';

const prefixScaleImageUrl = (value, options) => {
    if (isExternalUrl(value)) {
        return value;
    }
    else {
        var query = {
            path: value,
            context: options.context,
            width: options.width,
            height: options.height,
            bgcolor: options.bgcolor,
            position: options.position,
            padCanvas: options.padCanvas,
            cover: options.cover,
            maxScale: options.maxScale,
            fallbackPath: options.fallbackPath
        };
        const params = Object.keys(query)
            .filter(key => {
            const val = query[key];
            return val !== null && val !== undefined && val !== '';
        })
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
            .join('&');
        return `/.0/cms/scaleImage.aspx?${params}`;
    }
};

/**
 * Generated bundle index. Do not edit.
 */

export { prefixScaleImageUrl };
